<template>
  <audio src="" id="audioPlayer" autoplay>
    <p>If you are reading this, it is because your browser does not support the audio element.</p>
    <embed src="" width="180" height="90" hidden="true">
  </audio>
</template>

<script>
export default {
/* tslint:disable */
  data: function() {
    return {
      isPlaying: false
    };
  },
  mounted: function() {
    const path = './music/Song_small.mp3';
    const player = document.getElementById('audioPlayer');
    const home = document.getElementById('home');
    const OnClick = function() {
      if (!this.isPlaying) {
        player.src = path;
        player.play();
        this.isPlaying = true;
      }
    };
    home.addEventListener('load', OnClick);
    home.addEventListener('scroll', OnClick);
    home.addEventListener('click', OnClick, false);
    home.addEventListener('touchstart', OnClick, false);
  },
};
</script>

<style>
</style>
